import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = 'website',
  structuredData
}) => {
  const siteUrl = 'https://pedalxchange.com';
  const defaultTitle = 'PedalxChange - Trade Guitar Pedals Online | Buy, Sell & Trade Effects Pedals';
  const defaultDescription = 'Trade guitar pedals online with musicians worldwide. Buy, sell, and trade effects pedals safely with escrow protection. Find your next pedal trade today!';
  const defaultImage = `${siteUrl}/images/logo-email.png`;
  
  const seoTitle = title ? `${title} | PedalxChange` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url || siteUrl;
  const seoKeywords = keywords || 'trade guitar pedals, buy guitar pedals, sell effects pedals, trade effects pedals, guitar pedal marketplace, pedal trading, stompbox trading, boutique pedals, vintage pedals';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="4269" />
      <meta property="og:image:height" content="1869" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={seoUrl} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={seoUrl} />
      
      {/* Structured Data (JSON-LD) */}
      {structuredData && Array.isArray(structuredData) ? (
        structuredData.map((data, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))
      ) : structuredData ? (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      ) : null}
    </Helmet>
  );
};

export default SEO;

